<template>
	<div class="quote-form text-left">
		<!-- <h5 class='sec-hd'>Begin by entering city of your pickup location</h5> -->
		<h2 class="primary-hd">
			Where are you moving <b>from</b>?
		</h2>
		<location-search
			:button-text="submitButtonText"
			:placeholder="placeholder"
			:on-select="onCitySelect"
			type="origin"
		/>
	</div>
</template>

<script>
import locationSearch from '@/common/locationSearch';

export default {
	name: 'Pickup',
	components: {
		'location-search': locationSearch,
	},
	data() {
		return {
			step: 1,
			submitButtonText: 'Get Moving!',
			placeholder: 'ie Dallas, TX or 75201',
		};
	},
	mounted() {
		this.$store.dispatch('progress/updateProgress', this.step);
	},
	methods: {
		onCitySelect: function() {
			this.$router.push({
				name: this.$store.getters['progress/getNextStep'].name,
			});
		},
	},
};
</script>
